import { memo } from "react";

import { cn } from "@/lib/utils/cn";

interface SkeletonProps {
  className?: string;
  /** Render multiple stacked lines (e.g. for text blocks) */
  lines?: number;
}

/**
 * Animated shimmer placeholder for loading states.
 *
 * Usage:
 *   <Skeleton className="h-4 w-32" />
 *   <Skeleton lines={3} className="h-4" />
 */
const Skeleton = memo(function Skeleton({
  className,
  lines = 1,
}: SkeletonProps) {
  if (lines > 1) {
    return (
      <div className="space-y-2">
        {Array.from({ length: lines }).map((_, i) => (
          <div
            key={i}
            className={cn(
              "skeleton rounded",
              i === lines - 1 && "w-3/4", // last line shorter — natural text feel
              className,
            )}
          />
        ))}
      </div>
    );
  }

  return <div className={cn("skeleton rounded", className)} />;
});

export default Skeleton;
